export const colors = [
    {primary: { main: "#21468c"}, secondary: { main:"#4085e2"}},
    {primary: { main: "#223d7f"}, secondary: { main:"#c61a2b"}},
]


export function getColor(color) {

    let foundColor = colors.find(c => c.primary.main === color);
    if(foundColor) return foundColor;

    return colors[0]
}
